module.exports = __webpack_public_path__ + "img/fiber-intro.f58b395f.png";